'use client'

import { Brain, Bot, Eye, BarChart3 } from 'lucide-react'
import ServicePageTemplate from '@/components/ServicePageTemplate'

export default function AIMLServicesPage() {
  return (
    <ServicePageTemplate
      title="AI & ML"
      titleHighlight="Services"
      description="Intelligent automation, chatbots, machine learning models, and AI-powered solutions that transform your business operations."
      accentColor="from-violet-500 to-purple-600"
      stats={[
        { value: '80+', label: 'AI Projects' },
        { value: '95%', label: 'Model Accuracy' },
        { value: '10x', label: 'Efficiency Gain' },
        { value: '24/7', label: 'AI Support' }
      ]}
      services={[
        { icon: <Brain className="w-6 h-6" />, title: 'Machine Learning', description: 'Custom ML models for prediction and classification.', features: ['Predictive Analytics', 'Natural Language Processing', 'Recommendation Systems', 'Anomaly Detection'] },
        { icon: <Bot className="w-6 h-6" />, title: 'AI Chatbots', description: 'Intelligent conversational AI for customer engagement.', features: ['NLP-powered Bots', 'Multi-channel Support', 'Context Awareness', 'Human Handoff'] },
        { icon: <Eye className="w-6 h-6" />, title: 'Computer Vision', description: 'Image and video analysis for automation.', features: ['Object Detection', 'Image Classification', 'OCR Solutions', 'Video Analytics'] },
        { icon: <BarChart3 className="w-6 h-6" />, title: 'Data Analytics', description: 'Turn raw data into actionable business insights.', features: ['Data Pipelines', 'Business Intelligence', 'Real-time Dashboards', 'Predictive Modeling'] },
      ]}
      technologies={[
        { name: 'TensorFlow', category: 'Framework' }, { name: 'PyTorch', category: 'Framework' },
        { name: 'OpenAI', category: 'API' }, { name: 'Python', category: 'Language' },
        { name: 'Scikit-learn', category: 'Library' }, { name: 'Hugging Face', category: 'NLP' },
        { name: 'AWS SageMaker', category: 'Cloud' }, { name: 'MLflow', category: 'MLOps' },
      ]}
      process={[
        { step: '01', title: 'Data Assessment', description: 'Evaluate data quality, availability, and requirements.' },
        { step: '02', title: 'Model Design', description: 'Select algorithms and design model architecture.' },
        { step: '03', title: 'Training & Tuning', description: 'Train models and optimize hyperparameters.' },
        { step: '04', title: 'Validation', description: 'Rigorous testing and accuracy benchmarking.' },
        { step: '05', title: 'Deployment', description: 'Production deployment with monitoring pipelines.' },
        { step: '06', title: 'Continuous Learning', description: 'Ongoing model retraining and improvement.' },
      ]}
    />
  )
}
